import React from 'react';
import { Icon } from 'hfs-common-ui';
import BackButton, {
  Props as BackBtnProps,
} from '~/domain/add-asset/components/BackButton/BackButton';
import formatMessageWrapper from '~/utils/format-message-wrapper/format-message-wrapper';
import { LangKey } from '../../types';
import * as S from './styled';

export interface ModalHeaderProps {
  hideHeader: boolean;
  header?: React.ReactNode;
  infoOrErrorOrWarning: boolean;
  titleLang?: LangKey;
  isMobile: boolean;
  backBtnProps?: BackBtnProps;
  onClose?: () => void;
  showCloseIcon?: boolean;
  bottomBorder?: boolean;
  titleIcon?: React.ReactNode;
  id?: string;
  center?: boolean;
  headerAction?: React.ReactNode;
}

/**
 * @description Modal Header Component.
 */
const ModalHeader = ({
  hideHeader,
  header,
  infoOrErrorOrWarning,
  titleLang,
  isMobile,
  backBtnProps,
  onClose,
  showCloseIcon,
  titleIcon,
  id,
  center = false,
  bottomBorder = true,
  headerAction,
}: ModalHeaderProps) => {
  /** No Header for if hideHeader is there */
  if (hideHeader) {
    return null;
  }

  /** Return header node id in props */
  if (header) {
    return <>{header}</>;
  }

  const modalTitleText = titleLang && formatMessageWrapper(titleLang?.key, titleLang?.values);

  return (
    <S.ModalContentTitleDiv
      $infoOrErrorOrWarning={!!infoOrErrorOrWarning}
      $center={center}
      $bottomBorder={bottomBorder}
      $hasHeaderAction={!!headerAction}
      id={id ? `${id}-modal-title-container` : 'modal-title-container'}
    >
      {isMobile && !infoOrErrorOrWarning && !backBtnProps && (
        <BackButton
          onClick={onClose}
          id={id ? `${id}-mobile-back-action-btn` : 'mobile-back-action-btn'}
        />
      )}
      {backBtnProps && (
        <BackButton
          id={id ? `${id}-mobile-back-action-btn` : 'mobile-back-action-btn'}
          {...backBtnProps}
        />
      )}

      <h2 id={id ? `${id}-modal-title` : 'modal-title'} title={modalTitleText}>
        {titleIcon && (
          <S.IconSpan id={id ? `${id}-modal-title-icon` : 'modal-title-icon'}>
            {titleIcon}
          </S.IconSpan>
        )}
        {titleLang && <S.OverFlowEclipsedSpan>{modalTitleText}</S.OverFlowEclipsedSpan>}
      </h2>

      {!headerAction ? (
        showCloseIcon &&
        !isMobile && (
          <S.CloseIcon onClick={onClose} data-testid="modalCloseIcon">
            <Icon type="action.close" size="small" />
          </S.CloseIcon>
        )
      ) : (
        <S.HeaderActionDiv>{headerAction}</S.HeaderActionDiv>
      )}
    </S.ModalContentTitleDiv>
  );
};

export default ModalHeader;
